import { ArticleCategory, ArticleContentVideo, ArticlesCmsResource, RestrictionExclusion } from "@cardihab/content-cache";
export interface ArticleCategoryWithArticles extends ArticleCategory {
  articles: ArticlesCmsResource[];
}

export const YOUTUBE_EMBED_FLAGS_PARAMS = '?autoplay=1&rel=0';

export function getVideoUrl(article: ArticlesCmsResource) {
  return (article.content.find(c => c.__typename === 'ComponentArticleComponentsVideo') as ArticleContentVideo)?.videoUrl?.trim();
}

export function transformArticle(article: ArticlesCmsResource, carePlanReference: string = '', appId: string = ''): ArticlesCmsResource | undefined {
  if (article.baseArticleId) {
    return undefined;
  }

  let targetArticle = Object.assign({}, article);
  if (article.substitutes?.length) {
    const foundArticle = article.substitutes.find((art) => {
      return !checkIfArticleIsRestrictedOrExcluded(art.exclusions, art.restrictions, carePlanReference || '', appId || '');
    });
    if (foundArticle) {
      targetArticle = foundArticle;
    }
  }


  const isRestrictedOrExcluded = checkIfArticleIsRestrictedOrExcluded(targetArticle.exclusions, targetArticle.restrictions, carePlanReference || '', appId || '');
  if (isRestrictedOrExcluded) {
    return undefined;
  }

  const isVideo = targetArticle.articletype === 'video';
  let videoUrl = '';

  if (isVideo) {
    videoUrl = (targetArticle.content.find((content) => content.__typename === 'ComponentArticleComponentsVideo') as ArticleContentVideo)?.videoUrl || '';

    if (videoUrl && !targetArticle.thumbnailUrl) {
      videoUrl = videoUrl.trim();
      const YOUTUBE_EMBED_PREFIX = 'youtube.com/embed/';
      const YOUTUBE_NO_COOKIE_EMBED_PREFIX = 'youtube-nocookie.com/embed/';
      let urlParts = videoUrl.split(YOUTUBE_EMBED_PREFIX);
      if (urlParts.length < 2) {
        urlParts = videoUrl.split(YOUTUBE_NO_COOKIE_EMBED_PREFIX);
      }
      const videoId = urlParts.length > 1 ? urlParts[1] : '';
      targetArticle.thumbnailUrl = `http://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }
  }



  return targetArticle;
}

export function checkIfArticleIsRestrictedOrExcluded(exclusions: RestrictionExclusion, restrictions: RestrictionExclusion, careplanReference: string, appId: string): boolean {
  if (exclusions) {
    const carePlanExclusions = exclusions.careplans?.map((careplan: any) => careplan?.careplanIdentifier) || [];
    const appBundleExclusions = exclusions.app_bundles?.map((app_bundles: any) => app_bundles?.bundle_id) || [];
    if (carePlanExclusions.length && careplanReference) {
      if (carePlanExclusions.includes(careplanReference)) {
        return true;
      }
    }
    if (appBundleExclusions.length && appId) {
      if (appBundleExclusions.includes(appId)) {
        return true;
      }
    }
    // TODO::Tenancy restrictions
  }
  if (restrictions) {
    const carePlanRestrictions = restrictions.careplans?.map((careplan) => careplan?.careplanIdentifier) || [];
    const appBundleRestrictions = restrictions.app_bundles?.map((app_bundles) => app_bundles?.bundle_id) || [];
    if (carePlanRestrictions.length && careplanReference) {
      if (!carePlanRestrictions.includes(careplanReference)) {
        return true;
      }
    }
    if (appBundleRestrictions.length && appId) {
      if (!appBundleRestrictions.includes(appId)) {
        return true;
      }
    }
    // TODO::Tenancy restrictions
  }
  return false;
}
